/* src/routes/index.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	claim_component,
	claim_element,
	claim_space,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	query_selector_all,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { onMount } from "../../_snowpack/pkg/svelte.js";
import Gallery from "../../_components/Gallery.svelte.js";
import GalleryItem from "../../_components/GalleryItem.svelte.js";
import Theme from "../../_components/Theme.svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[1] = list[i].title;
	child_ctx[2] = list[i].thumbnail;
	child_ctx[3] = list[i].id;
	return child_ctx;
}

// (37:2) {#each Object.values(works) as { title, thumbnail, id }}
function create_each_block(ctx) {
	let galleryitem;
	let current;

	galleryitem = new GalleryItem({
			props: {
				id: /*id*/ ctx[3],
				title: /*title*/ ctx[1],
				thumbnail: /*thumbnail*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(galleryitem.$$.fragment);
		},
		l(nodes) {
			claim_component(galleryitem.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(galleryitem, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const galleryitem_changes = {};
			if (dirty & /*works*/ 1) galleryitem_changes.id = /*id*/ ctx[3];
			if (dirty & /*works*/ 1) galleryitem_changes.title = /*title*/ ctx[1];
			if (dirty & /*works*/ 1) galleryitem_changes.thumbnail = /*thumbnail*/ ctx[2];
			galleryitem.$set(galleryitem_changes);
		},
		i(local) {
			if (current) return;
			transition_in(galleryitem.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(galleryitem.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(galleryitem, detaching);
		}
	};
}

// (36:0) <Gallery>
function create_default_slot(ctx) {
	let each_1_anchor;
	let current;
	let each_value = Object.values(/*works*/ ctx[0]);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*Object, works*/ 1) {
				each_value = Object.values(/*works*/ ctx[0]);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

function create_fragment(ctx) {
	let title_value;
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let meta4;
	let t0;
	let theme;
	let t1;
	let gallery;
	let current;
	document.title = title_value = title;
	theme = new Theme({});

	gallery = new Gallery({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			t0 = space();
			create_component(theme.$$.fragment);
			t1 = space();
			create_component(gallery.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-185nic5\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { property: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { name: true, content: true });
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			claim_component(theme.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(gallery.$$.fragment, nodes);
			this.h();
		},
		h() {
			attr(meta0, "property", "og:title");
			attr(meta0, "content", title);
			attr(meta1, "property", "og:description");
			attr(meta1, "content", description);
			attr(meta2, "property", "og:image");
			attr(meta2, "content", "https://vec.ink/logo.png");
			attr(meta3, "property", "og:url");
			attr(meta3, "content", "https://vec.ink");
			attr(meta4, "name", "twitter:card");
			attr(meta4, "content", "summary_large_image");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			insert(target, t0, anchor);
			mount_component(theme, target, anchor);
			insert(target, t1, anchor);
			mount_component(gallery, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*title*/ 2) && title_value !== (title_value = title)) {
				document.title = title_value;
			}

			const gallery_changes = {};

			if (dirty & /*$$scope, works*/ 65) {
				gallery_changes.$$scope = { dirty, ctx };
			}

			gallery.$set(gallery_changes);
		},
		i(local) {
			if (current) return;
			transition_in(theme.$$.fragment, local);
			transition_in(gallery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(theme.$$.fragment, local);
			transition_out(gallery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			if (detaching) detach(t0);
			destroy_component(theme, detaching);
			if (detaching) detach(t1);
			destroy_component(gallery, detaching);
		}
	};
}

const prerender = true;

async function load({ fetch }) {
	const works = await fetch("/content").then(res => res.json());
	return { props: { works } };
}

const title = "vec.ink | code art sketchbook";
const description = "Shapes, patterns, colors, and code.";

function instance($$self, $$props, $$invalidate) {
	let { works } = $$props;

	$$self.$$set = $$props => {
		if ("works" in $$props) $$invalidate(0, works = $$props.works);
	};

	return [works];
}

class Routes extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { works: 0 });
	}
}

export default Routes;
export { prerender, load };
//# sourceMappingURL=index.svelte.js.map
